<template>
  <Design :customFonts="customFonts">
    <div :class="settingScreenSize.device">
      <div
        id="displayDevice"
        :ref="`displayDevice`"
        :class="`h-100 ${settingScreenSize.deviceDisplay}`"
      >
        <Skeleton :screenSize="screenSize" v-if="loading">
          <SkeletonMobile v-if="screenSize === 'Mobile'" />
          <SkeletonTablet v-else-if="screenSize === 'Tablet'" />
          <SkeletonDesktop v-else />
        </Skeleton>
        <div id="displayDeviceWrapper" class="w-100 h-100" style="overflow: hidden;">
          <iframe
            v-show="!loading"
            :class="`viewport${screenSize}`"
            @load="loaded"
            id="viewport"
            :ref="`viewport`"
            height="100%"
            :style="{
              '--iframe-scale': iframeScale,
              transform: `scale(${iframeScale})`,
              'transform-origin': 'top left',
              height: `calc(100%/${iframeScale})`,
              width: `calc(100%/${iframeScale})`,
            }"
            :src="buildDate ? `design-iframe?v=${Date.parse(buildDate)}` : 'design-iframe'"
          >
          </iframe>
        </div>
      </div>
      <div :class="settingScreenSize.device1"></div>
      <div :class="settingScreenSize.device2"></div>
      <div :class="settingScreenSize.device3"></div>
      <div :class="settingScreenSize.device4"></div>
    </div>
    <ManagePage />
    <Social />
    <ManageHeaderMenu />
    <TopMenu />
    <ManageFooterMenu />
    <FacebookLikeBox />
    <ModalUpdateFontStyle />
    <Filemanager ref="filemanager"></Filemanager>
    <AddLink2 />
    <AddLinkWidget />
    <AddSlideSection />
    <AddTabItem />
    <CannotAddWidgetAlert />
    <ModalPublish/>
    <ModalFontAwesome/>
    <CannotAddGridAlert />
  </Design>
</template>

<script>
import { mapGetters } from "vuex";
import { Design, Skeleton } from "./Design.styled";
import SkeletonDesktop from "@components_system/Design/Skeleton/SkeletonDesktop";
import SkeletonTablet from "@components_system/Design/Skeleton/SkeletonTablet";
import SkeletonMobile from "@components_system/Design/Skeleton/SkeletonMobile";

import ManagePage from "@components_system/Design/Modal/ManagePage/ManagePage";
import Social from "@components_system/Design/Modal/Widget/Social/Social";
import ManageHeaderMenu from "@components_system/Design/Modal/Header/ManageMenu/ManageMenu";
import TopMenu from "@components_system/Design/Modal/Widget/Header/TopMenu/TopMenu";
import ManageFooterMenu from "@components_system/Design/Modal/Footer/ManageMenu/ManageMenu";
import FacebookLikeBox from "@components_system/Design/Modal/Widget/Footer/FacebookLikeBox/FacebookLikeBox";
import ModalUpdateFontStyle from "@components_system/Design/Modal/ModalUpdateFontStyle/ModalUpdateFontStyle.vue";
import AddLink2 from "@components/dynamic/widget/tool/Modal/AddLink2/AddLink.vue";
import AddLinkWidget from "@components/dynamic/widget/tool/Modal/AddLink/AddLink.vue";
import AddSlideSection from "@components_system/Design/Modal/AddSlideSection/AddSlideSection.vue"
import CannotAddWidgetAlert from "@components_system/Design/Modal/Widget/Alert/CannotAddWidgetAlert";
import ModalPublish from "@components_system/Design/Modal/Publish/Publish";
import ModalFontAwesome from "@components_system/Design/Modal/FontAwesome/FontAwesome";
import AddTabItem from "@components_system/Design/Modal/AddTabItem/AddTabItem";
import CannotAddGridAlert from "@components_system/Design/Modal/Grid/Alert/CannotAddGridAlert";

import hotkeys from "hotkeys-js";
export default {
  components: {
    Design,
    Skeleton,
    SkeletonDesktop,
    SkeletonTablet,
    SkeletonMobile,
    ManagePage,
    Social,
    ManageHeaderMenu,
    TopMenu,
    ManageFooterMenu,
    FacebookLikeBox,
    ModalUpdateFontStyle,
    AddLink2,
    AddLinkWidget,
    AddSlideSection,
    CannotAddWidgetAlert,
    ModalPublish,
    ModalFontAwesome,
    AddTabItem,
    CannotAddGridAlert,
  },
  data() {
    return {
      loading: true,
      iframeScale: 1,
      iframeWin: undefined,
    };
  },

  mounted() {
    this.initShortkey();
    let iframeWin = document.getElementById("viewport").contentWindow;
    this.iframeWin = iframeWin;
    this.$store.dispatch("design/registerFilemanager", {
      filemanager: this.$refs.filemanager,
    });
    this.$store.dispatch("design/page/fetchPublishStatus");
    this.$store.dispatch("design/page/initialiseDesignIFrame", { iframeWin });

    this.handleResize();
    this.$router.push('/');
  },
  watch: {
    screenSize: function () {
      setTimeout(this.handleResize, 400);
    },
    screenWidth: function () {
      this.handleResize();
    },
    tempLogs() {
      this.setLogsLocal();
    }
  },
  methods: {
    setLogsLocal() {
      if(this.tempLogs && this.tempLogs.length) {
        const timeElapsed = Date.now();
        const today = new Date(timeElapsed);
        const date = today.toUTCString();

        const newLog = { [timeElapsed] : {
          date : date,
          data : this.tempLogs
        }};
        
        let oldLog = JSON.parse(localStorage.getItem(`LOG_${this.domainDisplay}`));

        if(oldLog) {
            Object.keys(oldLog).map(key => {
            const day = Math.floor((timeElapsed - key) / (1000*60*60*24))
            if(day >= 2) {
              delete oldLog[key];
            }
          });
        }

        const tempLog = {...oldLog,...newLog};

        localStorage.setItem(`LOG_${this.domainDisplay}`,JSON.stringify(tempLog));
        this.$store.dispatch('design/snapshot/setTempLogs',undefined);
      }
    },
    loaded() {
      this.loading = false;
    },
    registerHotkeys(key, callback) {
      hotkeys(key, (event) => {
        // Prevent the default refresh event under WINDOWS system
        event.preventDefault();
        callback();
      });
    },
    initShortkey() {
      this.registerHotkeys("command+z,ctrl+z", () =>
        this.$store.dispatch("design/snapshot/undo")
      );
      this.registerHotkeys("ctrl+y,command+y,command+shift+z", () =>
        this.$store.dispatch("design/snapshot/redo")
      );
    },

    handleResize() {
      // desktop min width 1366
      const scale = this.$refs.displayDevice.clientWidth / 1366;
      this.iframeScale = scale < 1 && this.screenSize === "Desktop" ? scale : 1;
      this.$store.dispatch("design/setIframeScale", { iframeScale: this.iframeScale })

      setTimeout(() => {
        this.$store.dispatch("designIframe/setIframeScale", { iframeScale: this.iframeScale })
        this.$store.dispatch("designIframe/frame/reRenderFrame")
      }, 400);
    },
  },
  computed: {
    ...mapGetters({
      elActiveID: "design/component/elActiveID",
      screenSize: "screenSize",
      screenWidth: "screenWidth",
      sections: "design/page/sections",
      customFonts: "design/site/customFonts",
      domains: "design/site/domains",
      logs: "design/snapshot/logs",
      logsIndex: "design/snapshot/logsIndex",
      tempLogs: "design/snapshot/tempLogs",
    }),
    domainDisplay() {
      return this.domains.main;
    },
    strLogs() {
      return JSON.stringify(this.logs);
    },
    settingScreenSize() {
      switch (this.screenSize) {
        case "Mobile":
          return {
            device: "device device-iphone-x",
            deviceDisplay: "device-frame",
            device1: "device-stripe",
            device2: "device-btns",
            device3: "device-power",
            device4: "device-home",
          };
        case "Tablet":
          return {
            device: "device device-ipad-pro device-spacegray",
            deviceDisplay: "device-frame",
            device1: "device-stripe",
            device2: "device-header",
            device3: "device-sensors",
            device4: "device-btns",
          };

        default:
          return {
            device: "device device-desktop h-100",
            deviceDisplay: "device-frame drop-shadow",
          };
      }
    },
    buildDate() {
      return process.env.VUE_APP_BUILDDATE;
    },
  },
};
</script>

<style>
</style>